import { render, staticRenderFns } from "./artifact_row.vue?vue&type=template&id=139d4b52"
import script from "./artifact_row.vue?vue&type=script&lang=js"
export * from "./artifact_row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports